export default __webpack_public_path__ + "static/media/elizabeth_may_preview.png";